<template>
  <div>
    <PageAllow controller="Coupons" action="index" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />

              <v-col>
                <v-btn
                        v-if="$permission.permissionAllow('Coupons', 'add')"
                        small
                        color="primary"
                        href="/#/material-coupons/detail/new"
                        class="ms-1 float-end"
                >
                  <v-icon x-small class="pe-1">fa-plus</v-icon>
                  {{ $t("CRUD.newInfo", [$t("MaterialCoupons.ObjectName")]) }}
                </v-btn>
              </v-col>

            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="keyword"
                    v-model="options.keyword"
                    @text="keyword = $event"
                    :label="$t('MaterialCoupons.Fields.name')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-select
                          v-model="options.type"
                          clearable
                          :items="$consts.coupons.coupon_type"
                          :label="$t('MaterialCoupons.Fields.type')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                          v-model="options.status"
                          :items="$consts.coupons.coupon_status"
                          :label="$t('MaterialCoupons.Status.title')"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="coupons"
          :options.sync="options"
          :loading="loading"
          mobile-breakpoint="800"
          multi-sort
          :page.sync="paging.page"
          :server-items-length="paging.count"
          class="elevation-2 px-4 pt-1"
          :footer-props="$t('$config.footer-props')"
        >
            <!--  发行数/领取数  -->
          <template v-slot:item.num="{ item }">
            <span v-if="item.num != null || item.receive_num != null">
              {{ item.num }} / {{item.receive_num}}
            </span>
          </template>

          <!--  有效期  -->
          <template v-slot:item.valid="{ item }">
            <span v-if="item.valid_start_date != null || item.valid_end_date != null">
              {{ item.valid_start_date }} ~ {{item.valid_end_date}}
            </span>
          </template>

          <!--  状态  -->
          <template v-slot:item.status="{ item }">
            <v-chip
                    small
                    label
                    :color="(item.status_str == '进行中') ? 'primary' : ''"
            >
              {{ item.status_str }}
            </v-chip>
          </template>

          <!-- 创建时间 -->
          <template v-slot:item.created="{ item }">
            <span>
              {{ item.created | formatTime }}
            </span>
          </template>

          <!--  操作  -->
          <template v-slot:item.actions="{ item }">
            <v-btn
                    v-if="$permission.permissionAllow('Coupons', 'view')"
                    small
                    dark
                    color="info"
                    class="px-2 me-2 mb-1"
                    @click.stop="
                $router.push('/material-coupons/detail/' + item.id)
              "
            >
              {{ $t("MaterialCoupons.Edit.detail") }}
            </v-btn>
            <!-- 复制 -->
             <v-btn
                v-if="$permission.permissionAllow('Coupons', 'add')"
                small
                dark
                color="info"
                class="px-2 me-2 mb-1"
                @click.stop="$router.push('/material-coupons/detail/' + item.id + '/clone')"
            >
              {{ $t("CRUD.clone") }}
            </v-btn>
            <!-- 作废 -->
            <v-btn
                    v-if="item.cancel_flg == 0 && $permission.permissionAllow('Coupons', 'cancel')"
                    small
                    dark
                    color="danger"
                    class="px-2 me-2 mb-1"
                    @click.stop="cancel(item.id)"
            >
              {{ $t("MaterialCoupons.Actions.cancel") }}
            </v-btn>
            <!-- 领取记录 -->
            <v-btn
                    v-if="$permission.permissionAllow('Coupons', 'receiveHistories')"
                    small
                    dark
                    color="primary"
                    class="px-2 me-2 mb-1"
                     @click.stop="$router.push('/material-coupons/receive-histories/' + item.id)"
                    
            >
              {{ $t("MaterialCoupons.Actions.receive") }}
            </v-btn>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import Coupons from "@/api/coupons";
import i18n from "@/i18n";


const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  keyword: "",
  status: [0],
};

export default {
  data: () => ({
    options: JSON.parse(
      sessionStorage.getItem("material-coupons-options")
        ? sessionStorage.getItem("material-coupons-options")
        : JSON.stringify(defaultOptions)
    ),
    loading: false,
    keyword: "",
    coupons: [],
    type:"",
    status:[],
    paging: {}
  }),
  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.materialManagement"),
        disabled: false,
        href: "/material-coupons",
      },
      {
        text: i18n.t("Nav.materialCoupons"),
        disabled: true,
        href: "/material-coupons",
      },
    ],
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("MaterialCoupons.Fields.created_time"),
      },
    ],
    headers: () => [
      {
        text: i18n.t("MaterialCoupons.Fields.name"),
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: i18n.t("MaterialCoupons.Fields.type"),
        align: "center",
        sortable: false,
        value: "type_str",
      },
      {
        text: i18n.t("MaterialCoupons.Fields.content"),
        align: "start",
        sortable: false,
        value: "coupon_content",
      },
      {
        text: i18n.t("MaterialCoupons.Fields.creater"),
        align: "center",
        sortable: false,
        value: "creater.name",
      },
      {
        text: i18n.t("MaterialCoupons.Fields.num") + ' / ' + i18n.t("MaterialCoupons.Fields.confine_num"),
        align: "center",
        sortable: false,
        value: "num",
      },
      {
        text: i18n.t("MaterialCoupons.Fields.use_num"),
        align: "center",
        sortable: false,
        value: "used_num",
      },
      {
        text: i18n.t("MaterialCoupons.Fields.valid"),
        align: "center",
        sortable: false,
        value: "valid",
      },
      {
        text: i18n.t("MaterialCoupons.Fields.status"),
        align: "center",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("MaterialCoupons.Fields.created_time"),
        align: "center",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        class: "text-no-wrap",
        sortable: false,
        value: "actions",
      },
    ],
  },
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherKeyword,
    SearcherStatus,
  },
  methods: {
    onSearch() {
      this.options = Object.assign({},this.options, {
        keyword: this.keyword
      });
    },
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getCouponsFromAPI() {
      this.loading = true;
      Coupons.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.coupons = response.data.coupons;
            this.paging = response.data.paging;

            let dayjs = require("dayjs");
            this.coupons.forEach((detail) => {
              if (detail.valid_start_date) {
                detail.valid_start_date = dayjs(detail.valid_start_date)
                        .format("YYYY-MM-DD");
              }
              if (detail.valid_end_date) {
                detail.valid_end_date = dayjs(detail.valid_end_date)
                        .format("YYYY-MM-DD");
              }
            })
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    cancel(id) {
      Coupons.cancel(id).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.getCouponsFromAPI();
                }
              }.bind(this)
      );
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        sessionStorage.setItem("material-coupons-options", JSON.stringify(this.options));
        this.getCouponsFromAPI();
      },
    },
    
  },
};
</script>

<style>
</style>